"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ValidationError = /*#__PURE__*/function (_Error) {
  function ValidationError(message, status, error) {
    var _this;
    (0, _classCallCheck2["default"])(this, ValidationError);
    _this = _callSuper(this, ValidationError, [message]);
    _this.name = "ValidationErrors";
    _this.status = status;
    _this.error = error;
    return _this;
  }
  (0, _inherits2["default"])(ValidationError, _Error);
  return (0, _createClass2["default"])(ValidationError);
}(/*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
var DataError = /*#__PURE__*/function (_Error2) {
  function DataError(message) {
    var _this2;
    (0, _classCallCheck2["default"])(this, DataError);
    _this2 = _callSuper(this, DataError, [message]);
    _this2.name = "DataError";
    return _this2;
  }
  (0, _inherits2["default"])(DataError, _Error2);
  return (0, _createClass2["default"])(DataError);
}(/*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
var ThrottledNetworkError = /*#__PURE__*/function (_Error3) {
  function ThrottledNetworkError() {
    var _this3;
    (0, _classCallCheck2["default"])(this, ThrottledNetworkError);
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    _this3 = _callSuper(this, ThrottledNetworkError, [].concat(params));
    (0, _defineProperty2["default"])(_this3, "type", "ThrottledNetworkError");
    return _this3;
  }
  (0, _inherits2["default"])(ThrottledNetworkError, _Error3);
  return (0, _createClass2["default"])(ThrottledNetworkError);
}(/*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
var buildCommonErrors = function buildCommonErrors(status) {
  switch (status) {
    case 400:
      return "Bad request executed";
    case 401:
      return "Unauthorized to make this request";
    case 403:
      return "Request is forbidden";
    case 404:
      return "Requested url not found, check url provided in the config";
    case 408:
      return "Request timed out";
    case 500:
      return "An error occurred on the server";
    default:
      return "An unknown error has occurred".concat(status ? " (status code ".concat(status, ")") : "");
  }
};
var buildAuthenticationErrorMessage = function buildAuthenticationErrorMessage(status) {
  switch (status) {
    case 400:
      return "Valid username and password fields are required";
    case 401:
      return "Invalid username or password";
    default:
      return buildCommonErrors(status);
  }
};
var buildLogoutErrorMessage = function buildLogoutErrorMessage(status) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var base = message ? "".concat(status, "-").concat(message) : null;
  switch (status) {
    case 401:
      return "Unauthorized";
    default:
      return base !== null && base !== void 0 ? base : buildCommonErrors(status);
  }
};
exports = module.exports = {
  ValidationError: ValidationError,
  DataError: DataError,
  ThrottledNetworkError: ThrottledNetworkError,
  buildCommonErrors: buildCommonErrors,
  buildAuthenticationErrorMessage: buildAuthenticationErrorMessage,
  buildLogoutErrorMessage: buildLogoutErrorMessage
};